import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { getCircularProgressStyle } from './FsCircularProgress.style';

const FsCircularProgress: React.FC = () => {
  const circularProgressStyle = getCircularProgressStyle();
  return <CircularProgress style={circularProgressStyle} />;
};

export default FsCircularProgress;
